var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _c(
        "v-card-title",
        [
          _c("span", { staticClass: "text-h5" }, [_vm._v("Buddy Insurance")]),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { icon: "" },
              on: {
                click: function($event) {
                  return _vm.$emit("modal-close")
                }
              }
            },
            [_c("v-icon", [_vm._v("mdi-close")])],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-container", { staticClass: "p-4" }, [
        _c("p", [
          _vm._v(
            "\n            By checking the box and purchasing Buddy Accident insurance, I acknowledge\n            that I have read, understand and agree to the\n            "
          ),
          _c(
            "a",
            {
              staticStyle: { "text-decoration": "underline", color: "blue" },
              attrs: {
                target: "_blank",
                href: "https://buddyinsurance.com/partners/policy-info/"
              }
            },
            [
              _c("strong", [
                _vm._v(
                  "important Disclosures, policy terms, conditions and exclusions."
                )
              ])
            ]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }